import { render, staticRenderFns } from "./industrial-addfication.vue?vue&type=template&id=57f8693f&scoped=true&"
import script from "./industrial-addfication.vue?vue&type=script&lang=js&"
export * from "./industrial-addfication.vue?vue&type=script&lang=js&"
import style0 from "./industrial-addfication.vue?vue&type=style&index=0&id=57f8693f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f8693f",
  null
  
)

export default component.exports